import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Videet Mehta Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <rect
          id="Shape"
          x="8"
          y="10"
          width="62"
          height="70"
          rx="8"
          ry="8"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path d="M30 30 L35 30 L39 50 L43 30 L48 30 L42 61 L36 61 L30 30 Z" fill="currentColor" />
      </g>
    </g>
  </svg>
);

export default IconLogo;
